import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";


@Injectable({
    providedIn: 'root'
})
export class DealService {
    constructor(private http: HttpClient) { }

    getDeal(): Observable<any> {
        return this.http.get<any>('api/content/deal');
    }
}